import { QuickActionCreateEvent } from '@app/gen/dashboard';

export interface QuickActionTypeWithId extends QuickActionCreateEvent {
  id: string;
}

export enum ContainerTypeEnum {
  Active = 'active',
  Available = 'available',
}
